import { createSlice } from '@reduxjs/toolkit';
import { getShopList } from './thunk';

const initialState = {
  shopList: null,
  successShopList: null,
  messageShopList: null,
};

const ShopList = createSlice({
  name: 'shopList',
  initialState,
  reducers: {
    reset(state) {
      return {
        ...state,
        successShopList: null,
        messageShopList: null,
      };
    },
  },
  extraReducers: {
    [getShopList.fulfilled]: (state, { payload }) => {
      //console.log('payloadpayloadpayloadpayload', payload)
      //console.log('payloadpayloadpayloadpayload(data)', payload.data)
      return {
        successShopList: null,
        messageShopList: null,
        shopList: payload.data.getShopAccount,
      };
    },
    [getShopList.rejected]: (state, action) => {
      return {
        ...state,
        successShopList: false,
        messageShopList: action.error.message,
      };
    },
  },
});
export const { reset } = ShopList.actions;
export default ShopList.reducer;
